import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import pl from './locales/pl.json'
import en from './locales/en.json'
import de from './locales/de.json'
import es from './locales/es.json'

const resources = {
  pl: { translation: pl },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n